import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    wrapper: {
        backgroundColor: '#fff',
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
        flexDirection: 'column',
        width: '100%',
        padding: '30px 64px',
        [theme.breakpoints.down('md')]: {
            display: 'block'
        }
    },
    userInfo: {
        display: 'flex',
        borderTop: `2px solid ${theme.palette.grey[200]}`,
        borderBottom: `2px solid ${theme.palette.grey[200]}`,
        '& > .userInfo': {
            width: '30%'
        },
        '& > .statusInfo': {
            width: '40%',
            backgroundColor: theme.palette.grey[100]
        },
        '& > .performance': {
            width: '30%'
        }
    },
    performanceContainer: {

    },
    banners: {
        marginTop: 22,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 15,
        '&:empty': {
            marginTop: 0
        }
    }
}));
